module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "data-vv-scope": "mu"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Organization Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accounts.organizationName),
      expression: "accounts.organizationName"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.accounts.organizationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accounts, "organizationName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Activation Date:")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": true,
      "lang": "en",
      "value-type": 'format',
      "confirm": false,
      "prefix-class": "xmx",
      "format": _vm.calendarFormat,
      "local": _vm.local
    },
    model: {
      value: (_vm.activationDate),
      callback: function($$v) {
        _vm.activationDate = $$v
      },
      expression: "activationDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("System ID:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accounts.systemId),
      expression: "accounts.systemId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.accounts.systemId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accounts, "systemId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Users limit:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accounts.usersLimit),
      expression: "accounts.usersLimit"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.accounts.usersLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accounts, "usersLimit", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("CaseMGR Account URL:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accounts.data.accountUrl),
      expression: "accounts.data.accountUrl"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.accounts.data.accountUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accounts.data, "accountUrl", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "caption-subject bold uppercase"
  }, [_vm._v("Create New Users")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('mu.fullName')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("* Full Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.fullName),
      expression: "user.fullName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "fullName",
      "type": "text",
      "data-vv-as": "Full Name"
    },
    domProps: {
      "value": (_vm.user.fullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "fullName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mu.fullName')),
      expression: "errors.has('mu.fullName')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('mu.fullName')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('mu.email')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("* Email Address:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "text",
      "data-vv-as": "Email Address"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mu.email')),
      expression: "errors.has('mu.email')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('mu.email')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticClass: "caption-subject bold uppercase"
  }, [_vm._v("Access")]), _c('br'), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-light table-hover"
  }, [_c('tbody', [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "mt-radio-inline"
  }, [_c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.picked),
      expression: "picked"
    }],
    attrs: {
      "type": "radio",
      "value": "2",
      "name": "userradio-2"
    },
    domProps: {
      "checked": _vm._q(_vm.picked, "2")
    },
    on: {
      "change": function($event) {
        _vm.picked = "2"
      }
    }
  }), _vm._v(" Yes\n                  "), _c('span')]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Case Manager")]), _vm._v(" - This access includes Volunteer privileges and allows users to add new\n              " + _vm._s(_vm.participantPluralName.toLowerCase()) + " and assignments, enter, edit, delete and view forms, generate reports, and modify the\n              " + _vm._s(_vm.participantSingularName) + "’s Assignment page.\n            ")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "mt-radio-inline"
  }, [_c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.picked),
      expression: "picked"
    }],
    attrs: {
      "type": "radio",
      "value": "3",
      "name": "userradio-3"
    },
    domProps: {
      "checked": _vm._q(_vm.picked, "3")
    },
    on: {
      "change": function($event) {
        _vm.picked = "3"
      }
    }
  }), _vm._v(" Yes\n                  "), _c('span')]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "mt-radio-inline"
  }, [_c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.picked),
      expression: "picked"
    }],
    attrs: {
      "type": "radio",
      "value": "4",
      "name": "userradio-4"
    },
    domProps: {
      "checked": _vm._q(_vm.picked, "4")
    },
    on: {
      "change": function($event) {
        _vm.picked = "4"
      }
    }
  }), _vm._v(" Yes\n                  "), _c('span')]), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "mt-radio-inline"
  }, [_c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.picked),
      expression: "picked"
    }],
    attrs: {
      "type": "radio",
      "value": "5",
      "name": "userradio-5"
    },
    domProps: {
      "checked": _vm._q(_vm.picked, "5")
    },
    on: {
      "change": function($event) {
        _vm.picked = "5"
      }
    }
  }), _vm._v(" Yes\n                  "), _c('span')]), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), (_vm.logged.access > 5) ? _c('tr', [_vm._m(7), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "mt-radio-inline"
  }, [_c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.picked),
      expression: "picked"
    }],
    attrs: {
      "type": "radio",
      "value": "6",
      "name": "userradio-6"
    },
    domProps: {
      "checked": _vm._q(_vm.picked, "6")
    },
    on: {
      "change": function($event) {
        _vm.picked = "6"
      }
    }
  }), _vm._v(" Yes\n                  "), _c('span')]), _vm._v(" "), _vm._m(8)])])]) : _vm._e()])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('router-link', {
    staticClass: "btn default",
    attrs: {
      "to": {
        name: 'Manage Account List'
      },
      "tag": "button"
    }
  }, [_vm._v("\n      Cancel\n    ")]), _vm._v(" "), (_vm.logged.access > 5) ? _c('router-link', {
    staticClass: "btn green pull-right",
    attrs: {
      "to": {
        name: 'Manage Account List'
      },
      "tag": "button"
    }
  }, [_vm._v("\n      Account Directory\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.accounts.users != null && _vm.accounts.users.length) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.accounts.users,
      "pagination-options": {
        enabled: true
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'fullName') ? _c('span', [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.showUserModal(props.row.id)
            }
          }
        }, [_vm._v(_vm._s(props.row.fullName))])]) : (props.column.field == 'lastLogin') ? _c('span', [(!props.row.confirmed) ? _c('span', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.resendActivation(props.row.id)
            }
          }
        }, [_c('a', [_vm._v(" Resend Activation ")])]) : (props.row.lastLogin) ? _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(props.row.lastLogin)))]) : _vm._e()]) : (props.column.field == 'access') ? _c('span', [_vm._v("\n        " + _vm._s(_vm.userRoles[props.row.access]) + "\n      ")]) : (props.column.field == 'enabled') ? _c('span', [_c('div', {
          staticClass: "last-dropdown"
        }, [_c('actions-menu', [(!(_vm.logged.access < 6 && props.row.access == 6)) ? _c('actions-menu-item', {
          attrs: {
            "title": (props.row.enabled) ? 'Deactivate' : 'Activate',
            "icon": (props.row.enabled) ? 'fa-remove' : 'fa-check'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.toggleActivation(props.row.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('actions-menu-item', {
          attrs: {
            "title": "Show Activity",
            "icon": "fa-list-ul"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.showActivityModal(props.row.id)
            }
          }
        }), _vm._v(" "), _c('actions-menu-item', {
          attrs: {
            "title": "Show User Access",
            "icon": "fa-lock"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.showUserAccessModal(props.row.id)
            }
          }
        })], 1)], 1)]) : _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }], null, false, 1643253036)
  }) : _vm._e(), _vm._v(" "), (_vm.displayActivityModal) ? _c('user-activity-log-modal', {
    attrs: {
      "id": _vm.activityLogUserId
    },
    on: {
      "hide": function($event) {
        _vm.displayActivityModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.displayUserAccessModal) ? _c('user-access-modal', {
    attrs: {
      "id": _vm.userAccessUserId
    },
    on: {
      "display": function($event) {
        _vm.displayUserAccessModal = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Volunteer")]), _vm._v(" - This access allows users to view the Participant Dashboard, and enter and view Participant forms.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    staticClass: "userradio-no",
    attrs: {
      "type": "radio",
      "value": "0",
      "name": "userradio-2",
      "disabled": "disabled"
    }
  }), _vm._v(" No\n                  "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    staticClass: "userradio-no",
    attrs: {
      "type": "radio",
      "value": "0",
      "name": "userradio-3",
      "checked": "checked",
      "disabled": "disabled"
    }
  }), _vm._v(" No\n                  "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Supervisor")]), _vm._v(" - This access includes Case Manager privileges and allows users to view a Caseload Summary for each Case Manager, view the Referral Dashboard, and create, edit, generate, and publish reports.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    staticClass: "userradio-no",
    attrs: {
      "type": "radio",
      "value": "0",
      "name": "userradio-4",
      "checked": "checked",
      "disabled": "disabled"
    }
  }), _vm._v(" No\n                  "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Program Administrator")]), _vm._v(" - This access includes Supervisor privileges and allows users to access\n              Administrative Settings, manage users, import data, and create, edit, generate and publish forms.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    staticClass: "userradio-no",
    attrs: {
      "type": "radio",
      "value": "0",
      "name": "userradio-5",
      "checked": "checked",
      "disabled": "disabled"
    }
  }), _vm._v(" No\n                  "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("System Administrator")]), _vm._v(" - This access includes Program Administrator privileges and allows users\n              to access all accounts and functionality.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mt-radio"
  }, [_c('input', {
    staticClass: "userradio-no",
    attrs: {
      "type": "radio",
      "value": "0",
      "name": "userradio-6",
      "checked": "checked",
      "disabled": "disabled"
    }
  }), _vm._v(" No\n                  "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn green mt-ladda-btn ladda-button account-btn-create-user",
    attrs: {
      "data-style": "expand-left",
      "type": "submit"
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Create User")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-666413a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/ManageUsersForm.vue
// module id = 1676
// module chunks = 1